import {
  flattenSurveyAnswers,
  hasUserCompletedEnoughOfGettingStartedSurvey,
  hasUserCompletedCologuardQualificationSurvey,
  hasUserCompletedCologuardPersonalizedResourcesSurvey
} from "utils/v3/surveyUtils";
import { doesMemberNeedToTalkToNavBasedOnFlattenedSurveyAnswers } from "utils/v3/testKitUtils";
import {
  getColonCancerScreeningAgeBand,
  hasMemberReportedCancer,
  isMemberEligibleForColonCancerScreeningPrompt
} from "utils/v3/nextMoveUtils";
import { useSelector } from "react-redux";
import { selectAllPreviousSurveyAnswers } from "store/reducers/survey/SurveySlice";
import {
  selectCologuardTestRedirectIsEligible,
  selectExistingOrdersWithoutCancelled
} from "store/reducers/order/OrderInformationSlice";
import { selectUserPersonalInformation } from "store/reducers/user/UserAccountSlice";

export const useNextMoveMemberContext = () => {
  const previousSurveyAnswers = useSelector(selectAllPreviousSurveyAnswers);
  const kitsAlreadyOrdered = useSelector(selectExistingOrdersWithoutCancelled);
  const isEligibleForCologuardTestRedirect = useSelector(
    selectCologuardTestRedirectIsEligible
  );
  const userInformation = useSelector(selectUserPersonalInformation);
  const flattenedSurveyAnswers = flattenSurveyAnswers(previousSurveyAnswers);
  const memberNeedsToTalkToNav =
    doesMemberNeedToTalkToNavBasedOnFlattenedSurveyAnswers(
      flattenedSurveyAnswers
    ) && !kitsAlreadyOrdered.length;

  return {
    colonCancerScreeningAgeBand: getColonCancerScreeningAgeBand(
      userInformation.dob
    ),
    flattenedSurveyAnswers,
    hasCompletedCologuardQualificationSurvey:
      hasUserCompletedCologuardQualificationSurvey(previousSurveyAnswers),
    hasCompletedCologuardPersonalizedResourcesSurvey:
      hasUserCompletedCologuardPersonalizedResourcesSurvey(previousSurveyAnswers),
    hasCompletedEnoughOfGettingStartedSurvey:
      hasUserCompletedEnoughOfGettingStartedSurvey(previousSurveyAnswers),
    hasReportedCancer: hasMemberReportedCancer(flattenedSurveyAnswers),
    isMemberActive: Boolean(userInformation.isMemberActive),
    isEligibleForCologuardTestRedirect,
    isMemberEligibleForColonCancerScreeningPrompt:
      isMemberEligibleForColonCancerScreeningPrompt(userInformation.dob),
    kitsAlreadyOrdered,
    memberNeedsToTalkToNav,
    previousSurveyAnswers,
    userInformation
  };
};
